import React from 'react';

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export default function ImportConditionsSAVDialog({ importData, onClose }) {


    return (

        <Dialog open={!!importData}>

            {!!importData && (
                    <>         

                        <DialogTitle>Résultat de l'import de conditions SAV</DialogTitle>
                        <DialogContent>

                        
                        {importData.result && (
                            <>
                                <Typography>Import effectué avec succès</Typography>
                                <Typography>Nombre de conditions ajoutées = {importData.nbConditionsAjoutees}</Typography>
                                <Typography>Nombre de conditions modifiées = {importData.nbConditionsModifiees}</Typography>
                                <Typography>Nombre de conditions inchangées = {importData.nbConditionsInchangees}</Typography>
                            </>
                        )}


                        {!importData.result && (
                            <>
                                <Typography>Échec de l'import</Typography>
                                <Typography>Nombre de conditions ajoutées = {importData.nbConditionsAjoutees}</Typography>
                                <Typography>Nombre de conditions modifiées = {importData.nbConditionsModifiees}</Typography>
                                <Typography>Nombre de conditions inchangées = {importData.nbConditionsInchangees}</Typography>
                            </>
                        )}

                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={onClose}
                                variant="contained"
                                color="secondary"
                            >
                                Ok
                            </Button>
                        </DialogActions>


                    </>
            )}

        </Dialog>
    );


}